import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'
import { IFSC } from './getAllBanks'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const getBranchBody = (bankName: string, cityName: String) => {
  return {
    bankName: bankName,
    bankCity: cityName,
    bankBranch: '',
    source: IFSC,
  }
}

export const getAllBranches = (tokens: any, bankName: string, cityName: string) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.getIfscCode,
    method: 'POST',
    config: config,
    body: getBranchBody(bankName, cityName),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
